// extracted by mini-css-extract-plugin
export default {"iframes_container":"MapStore_iframes_container__hKXSF","iframes_smaller_imgs":"MapStore_iframes_smaller_imgs__z-6Jp"};